import React, { useEffect, useState } from "react";
import { Row, Col, Form, Table, Pagination, notification } from "antd";
import UserHeader from "../../components/header/UserHeader";
import UserDrawer from "../../components/drawer/UserDrawer";
import { componentStyles } from "./ProfileStyles";
import { componentConversationStyles } from "./PreviousConversationsStyles";
import { getConversations, getConversationsSentiments, getUser } from "../../api/password";
import ClipLoader from "react-spinners/ClipLoader";
import { useNavigate } from "react-router-dom";
import "../onboarding/UserOnboardingPage.css";
import "./PreviousConversationsStyle.css";
import goBackButton from "../../assets/images/Go_Back.svg";
import eyeIcon from "../../assets/images/eye.svg";
import downloadIcon from "../../assets/images/Download.svg";
import printIcon from "../../assets/images/Print.svg";
import moment from "moment";
import { getRequest } from "../../api";

const perPageRecords = 10;

const PreviousConversations = () => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [loader, setLoader] = useState(true);
    const [conversations, setConversations] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [nameOfUser, setNameOfUser] = useState("User");
    const [form] = Form.useForm();
    const [messageApi] = notification.useNotification();
    const navigate = useNavigate();

    const [selectedVoice, setSelectedVoice] = useState('Amy');
    const userId = Number(localStorage.getItem('userid')); 
    
    
    useEffect(() => {
      const fetchAvatar = async () => {
        try {
          const response = await getRequest('/user/get-avatar');
    
          if (response.error) {
            console.error("Error fetching avatar:", response.error);
            setSelectedVoice('Amy'); 
          } else {
            const avatar = response.avatar;
    
            if (avatar === 'Arthur' || avatar === 'Amy') {
              setSelectedVoice(avatar); 
            } else {
              setSelectedVoice('Amy'); 
            }
          }
        } catch (error) {
          console.error("Error fetching avatar:", error);
          setSelectedVoice('Amy'); 
        }
      };
    
      if (userId) {
        fetchAvatar();
      } else {
        console.error("User ID is missing in localStorage.");
        setSelectedVoice('Amy'); 
      }
    }, [userId]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoader(true);
                const responseName = await getUser();
                setNameOfUser(responseName.name);
                let userId = localStorage.getItem("userid");
                const response = await getConversations(userId, currentPage);
                const mappedData = response.rows.map((conversation) => ({
                    key: conversation.id,
                    selectedAvatar: conversation.selectedAvatar ? `Chat with ${conversation.selectedAvatar}` : "Open Conversation",
                    dateCreated: moment(conversation.createdAt).format("DD-MM-YYYY"),
                    timeTaken: calculateTimeDifference(conversation.startTime, conversation.endTime),
                    amazonSessionId: conversation.amazonSessionId,
                    date: conversation.createdAt
                }));
                setConversations(mappedData);
                setTotalPages(Math.ceil(response.count / perPageRecords));
            } catch (err) {
                console.error("Error fetching data:", err);
            } finally {
                setLoader(false);
            }
        };

        fetchData();
    }, [currentPage, form]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const calculateTimeDifference = (startTime, endTime) => {
        const timeFormat = "HH:mm:ss";
        const start = moment(startTime, timeFormat);
        const end = moment(endTime, timeFormat);

        if (!start.isValid() || !end.isValid()) {
            console.error("Invalid date format");
            return "Invalid date";
        }
        const duration = moment.duration(end.diff(start));
        const hours = Math.floor(duration.asHours());
        const minutes = duration.minutes();
        const seconds = duration.seconds();
        const formattedTime = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
        return formattedTime;
    };

    const openDrawer = () => {
        setIsDrawerOpen(true);
    };

    const closeDrawer = () => {
        setIsDrawerOpen(false);
    };

    const sectionsContainerStyle = {
        transition: "opacity 0.3s ease, pointer-events 0.3s ease",
        opacity: isDrawerOpen ? "0.5" : "1",
        pointerEvents: isDrawerOpen ? "none" : "auto",
    };

    const handleViewConversation = (record) => {
        navigate(`/individual-conversation/${record.amazonSessionId}`, {
            state: { conversationData: record }
        });
    };

    const removeMiscellaneousText = (text) => {
      if (!text) {
        return "";
      }
      let cleanedText = text
        .replace(
          /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
          ""
        )
        .trim();
      cleanedText = cleanedText.replace(/^(Kano\s*:?"?\s*)/, "");
      return cleanedText;
    };

    const sanitizeJsonString = (jsonString) => {
      let sanitized = jsonString.replace(/[\u0000-\u001F\u007F-\u009F]/g, "").trim();
      return sanitized;
    };

    const jsonFormatter = (item) => {
      try {
        const sanitizedContent = sanitizeJsonString(item.content);
        
        const parsedContent = JSON.parse(sanitizedContent);

        if (parsedContent.message) {
          return removeMiscellaneousText(parsedContent.message);
        }
      } catch (error) {
        console.error("JSON parsing error:", error, "Original Content:", item.content);
      }

      return "Error: Invalid JSON content";
    };

    const handleDownloadConversation = async (record) => {
        try {
            const response = await getConversationsSentiments(record.amazonSessionId);
            const conversationContent = response.Item.Conversation;

            let formattedText = conversationContent.map((item) => {
                const message = jsonFormatter(item);
                // const roleName = item.role === "assistant" ? `${selectedVoice}` : item.role === "user" ? nameOfUser || "User" : "No role";
                const roleName = item.role === "assistant" ? `My Friend` : item.role === "user" ? nameOfUser || "User" : "No role";
                return `Role: ${roleName}\nContent: ${message || "No content"}\n\n`;
            }).join('\n');

            const element = document.createElement("a");
            const file = new Blob([formattedText], { type: "text/plain" });
            element.href = URL.createObjectURL(file);
            element.download = `conversation_${record.amazonSessionId}.txt`;
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);

        } catch (err) {
            console.error("Error downloading conversation:", err);
            notification.error({
                message: "Error",
                description: "Failed to download conversation",
                duration: 10
            });
        }
    };

    const handlePrintConversation = async (record) => {
        try {
            const response = await getConversationsSentiments(record.amazonSessionId);
            const conversationContent = response.Item.Conversation;
    
            let formattedText = conversationContent.map((item) => {
                let content;
                try {
                    const sanitizedContent = sanitizeJsonString(item.content);
                    content = JSON.parse(sanitizedContent);
                } catch (error) {
                    console.error("Error parsing JSON:", error);
                    content = { message: "Invalid content" }; 
                }
    
                const message = content.message || "No message";
                // const roleName = item.role === "assistant" ? `${selectedVoice}` : item.role === "user" ? nameOfUser || "User" : "No role";
                const roleName = item.role === "assistant" ? `My Friend` : item.role === "user" ? nameOfUser || "User" : "No role";
                return `Role: ${roleName}\nContent: ${message || "No content"}\n\n`;
            }).join('\n');
    
            const printWindow = window.open("", "", "height=600,width=800");
            printWindow.document.write(`
                <html>
                <head>
                    <title>Print Conversation</title>
                    <style>
                        body { font-family: Arial, sans-serif; margin: 20px; }
                        pre { white-space: pre-wrap; }
                    </style>
                </head>
                <body>
                    <h1>Conversation with My Friend</h1>
                    <pre>${formattedText}</pre>
                    <script>
                        window.onload = function() {
                            window.print();
                            window.onafterprint = function() {
                                window.close();
                            }
                        }
                    </script>
                </body>
                </html>
            `);
    
            printWindow.document.close();
            printWindow.focus();
    
        } catch (err) {
            console.error("Error printing conversation:", err);
            notification.error({
                message: "Error",
                description: "Failed to print conversation",
                duration: 10
            });
        }
    };
    const handleBack = () => {
        navigate("/landing-page");
    };
    
    const columns = [
        {
            title: <div style={{ backgroundColor: '#F3FDFF' }}>Conversation Title</div>,
            dataIndex: 'selectedAvatar',
            key: 'selectedAvatar',
            align: 'center',
        },
        {
            title: <div style={{ backgroundColor: '#F3FDFF' }}>Date Created</div>,
            dataIndex: 'dateCreated',
            key: 'dateCreated',
            align: 'center',
        },
        {
            title: <div style={{ backgroundColor: '#F3FDFF' }}>Time Taken</div>,
            dataIndex: 'timeTaken',
            key: 'timeTaken',
            align: 'center',
        },
        {
            title: <div style={{ backgroundColor: '#F3FDFF' }}>View Conversation</div>,
            key: 'view',
            align: 'center',
            render: (_, record) => (
                <img
                    src={eyeIcon}
                    alt="View"
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleViewConversation(record)}
                />
            ),
        },
        {
            title: <div style={{ backgroundColor: '#F3FDFF' }}>Download Conversation</div>,
            key: 'download',
            align: 'center',
            render: (_, record) => (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <img
                        src={downloadIcon}
                        alt="Download"
                        style={{ cursor: 'pointer', marginRight: '10px' }}
                        onClick={() => handleDownloadConversation(record)}
                    />
                    <img
                        src={printIcon}
                        alt="Print"
                        style={{ cursor: 'pointer' }}
                        onClick={() => handlePrintConversation(record)}
                    />
                </div>
            ),
        },
    ];

    return (
        <div style={{ minHeight: "100dvh", overflow: "hidden", background: "#fefcfe" }}>
            <Col xs={24} sm={24} lg={24} md={24} style={sectionsContainerStyle}>
                <Row justify={{ xs: "space-around", md: "space-around", lg: "space-between" }} style={{ marginBottom: 20 }}>
                    <Col xs={{ span: 22 }} lg={{ span: 24 }} md={{ span: 22 }}>
                        <UserHeader setDrawer={openDrawer} />
                    </Col>
                    {isDrawerOpen && (
                        <Col span={4}>
                            <UserDrawer isDrawerOpen={isDrawerOpen} onClose={closeDrawer} />
                        </Col>
                    )}
                </Row>
                <button onClick={handleBack}  className="text-left pl-4 button-styling setBackButton">
                  <img src={goBackButton} alt="Go Back Button" />
                </button>
                {loader ? (
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "200px" }}>
                        <ClipLoader loading={loader} size={50} aria-label="Loading Spinner" data-testid="loader" />
                    </div>
                ) : (
                    <Form form={form}>
                        <Row justify="center" style={{ padding: "25px" }}>
                            <Col span={20} style={{ paddingLeft: "2%" }}>
                                <Row>
                                    <Col xs={24} sm={24} md={24} lg={24}>
                                        <Row style={componentStyles.rowStyling}>
                                            <h1 style={componentConversationStyles.headingStyle}>View Your Previous Conversations</h1>
                                        </Row>
                                    </Col>
                                </Row>
                                <Table dataSource={conversations} columns={columns} className="centered-table" pagination={false} />
                                <Pagination
                                    current={currentPage}
                                    pageSize={perPageRecords}
                                    total={totalPages * perPageRecords}
                                    onChange={handlePageChange}
                                    style={{ marginTop: "40px", textAlign: "right" }}
                                />
                            </Col>
                        </Row>
                    </Form>
                )}
            </Col>
        </div>
    );
};

export default PreviousConversations;